import create from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { devtools, persist, subscribeWithSelector } from 'zustand/middleware'

type ISettingsState = {
  packagesSortByLatestStateDate: boolean
  togglePackagesSortByLatestStateDate: () => void
}

const state = (set): ISettingsState => ({
  packagesSortByLatestStateDate: false,
  togglePackagesSortByLatestStateDate: () =>
    set(state => ({ packagesSortByLatestStateDate: !state.packagesSortByLatestStateDate })),
})

export const useSettingsStore = create<ISettingsState>()(
  subscribeWithSelector(
    persist(
      immer(
        devtools(state, {
          name: 'settingsStore',
        })
      ),
      {
        name: 'settings',
        getStorage: () => localStorage,
      }
    )
  )
)
